import type { ContractAction } from '@paid-ui/enums/requiring-action';
import type { ContractParticipantParty } from '@paid-ui/types';

export const checkPermission = (
  action: ContractAction,
  party?: ContractParticipantParty | null,
) => {
  if (!party) {
    return false;
  }

  if (!party.role) {
    return true;
  }

  const actions = party.role.actions ?? [];
  return actions.includes(action);
};
